import { Megaphone, Users, CalendarDays, Award, BookOpen } from "lucide-react";

export const ESSAP_CATS = [
  { key: "communiques", label: "Communiqués", icon: Megaphone, desc: "Annonces officielles de l'administration de l'ESSAP." },
  { key: "etudiants-retenus", label: "Étudiants retenus", icon: Users, desc: "Listes des étudiants retenus à l'ESSAP." },
  { key: "programmes-examens", label: "Programmes d'examens", icon: CalendarDays, desc: "Calendriers et programmes des examens." },
  { key: "resultats", label: "Résultats des examens", icon: Award, desc: "Résultats publiés des examens." },
  { key: "activites", label: "Activités académiques", icon: BookOpen, desc: "Autres activités académiques de l'ESSAP." },
];

export const catLabel = (k) => ESSAP_CATS.find((c) => c.key === k)?.label || k;
